import { useTranslation } from 'react-i18next'
import { common } from '@ocean/ui'
import { NavControlGroup } from 'components/navigation/common'
import { NavigationLink } from './NavLinkGroup.styled'

const { Typography } = common

type Link = {
  to: string
  title: string
  hidden?: boolean
  dataTest?: string
}

type NavLinkGroupProps = {
  links: Link[]
}

const NavLinkGroup: React.FC<NavLinkGroupProps> = ({ links }) => {
  const { t } = useTranslation()

  return (
    <NavControlGroup data-test='NavLinkGroup'>
      {links.map(({ to, title, hidden, dataTest }) => {
        if (hidden) return null
        return (
          <NavigationLink to={to} key={to} data-test={dataTest || 'NavigationLink'}>
            <Typography variant='h4' dataTest='NavigationLinkTitle'>
              {t(title)}
            </Typography>
          </NavigationLink>
        )
      })}
    </NavControlGroup>
  )
}

export default NavLinkGroup
